module.exports = __webpack_public_path__ + "img/aiem.fd80ea73.jpg";